const { VUE_APP_PUBLICK_PATH } = process.env

export function convertLocalPath(src) {
    return src.replace(`${VUE_APP_PUBLICK_PATH}`, '/')
}